import { Select } from "element-ui";

export const tableOption = {
    border: true,
    stripe: true,
    menuAlign: 'center',
    editBtn: false,
    delBtn: false,
    align: 'center',
    addBtn: false,
    refreshBtn: false,
    column: [
      {
        label: '头像',
        width: 100,
        prop: 'avatar',
        solt:true
      },
      {
        label: '员工号',
        width: 160,
        prop: 'unionId',
        span: 24
      },      
      {
        label: 'Birth Name',
        width: 160,
        prop: 'realname',
        span: 24,
      },        
      {
        label: 'Full Name',
        width: 160,
        prop: 'nickname',
        span: 24
      },    
      {
        label: '手机号',
        width: 160,
        prop: 'phoneNumber',
        solt: true,
        span: 24,
      },
      {
        label: 'Position Name',
        width: 160,
        prop: 'position',
        span: 24,
      },
      {
        label: 'Organizational Unit Name',
        width: 260,
        prop: 'organizationalUnitName',
        span: 24,
      },
      {
        label: 'Leader',
        width: 200,
        prop: 'leader',
        span: 24,
      },
      {
        label: 'Staffing Model',
        width: 200,
        prop: 'staffingModel',
        span: 24,
      },
      // {
      //   label: '邮箱',
      //   width: 160,
      //   prop: 'email',
      //   span: 24,
      //   hide: true,
      // },
      // {
      //   label: '性别',
      //   width: 70,
      //   prop: 'gender',
      //   span: 24,
      //   hide: true,
      //   dicData: [{
      //     label: '男',
      //     value: 'MALE'
      //   }, {
      //     label: '女',
      //     value: 'FEMALE'
      //   }]
      // },
      {
        label: '在职/离职',
        type: 'select',
        width: 90,
        prop: 'isActive',
        span: 24,
        dicData: [{
          label: '在职',
          value: true
        }, {
          label: '离职',
          value: false
        }]
      },
      // {
      //   label: '账号等级',
      //   width: 150,
      //   prop: 'personalTierName',
      //   span: 24,
      // },
      {
        label: '禁言状态',
        type: 'select',
        width: 90,
        prop: 'isBanned',
        span: 24,
        dicData: [{
          label: '未禁言',
          value: false
        }, {
          label: '已禁言',
          value: true
        }]
      },
      {
        label: '禁言截止时间',
        width: 120,
        prop: 'bannedEndTime',
        span: 24,
        hide: true,
      },
      // {
      //   label: '公司名称',
      //   width: 120,
      //   prop: 'company',
      //   span: 24,
      //   hide: true,
      // },
      // {
      //   label: '部门名称',
      //   width: 120,
      //   prop: 'position',
      //   span: 24,
      //   hide: true,
      // },
      // {
      //   label: '地区',
      //   width: 120,
      //   prop: 'location',
      //   span: 24,
      //   hide: true,
      // },
      // {
      //   label: '圈子量',
      //   width: 100,
      //   prop: 'circleJoinedCount',
      //   sortable: true,
      //   span: 24,
      // },
      // {
      //   label: '总积分',
      //   width: 100,
      //   prop: 'totalReward',
      //   solt: true,
      //   sortable: true,
      //   span: 24,
      // },
      // {
      //   label: '广场帖子数',
      //   width: 120,
      //   prop: 'postCount',
      //   solt: true,
      //   sortable: true,
      //   span: 24,
      // },
      // {
      //   label: '评论量',
      //   width: 100,
      //   prop: 'commentCount',
      //   solt: true,
      //   sortable: true,
      //   span: 24,
      // },
      // {
      //   label: '已关注',
      //   width: 100,
      //   prop: 'followCount',
      // },
      // {
      //   label: '粉丝',
      //   width: 100,
      //   prop: 'fansCount',
      //   span: 24,
      // },
      {
        label: '创建时间',
        width: 160,
        prop: 'insertedTime',
        sortable: true,
        type: 'datetime',
        format: 'yyyy-MM-dd HH:mm',
        valueFormat: 'yyyy-MM-dd HH:mm:ss.000',
        editDisabled: true,
        addVisdiplay: false,
        span: 24
      },]
}

export const memberOrganizationTagTableOption = {
  border: true,
  stripe: true,
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  refreshBtn: false,
  menu: true,
  menuAlign: 'center',
  menuSpan: 24,
  column: [
    {
      label: '用户ID',
      prop: 'memberId',
      span: 24
    },
    {
      label: '员工号',
      prop: 'unionId',
      span: 24
    },
    {
      label: 'Birth Name',
      prop: 'realname',
      span: 24,
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss.000',
      span: 24,
      sortable: true
    },
    {
      label: '标签名称',
      prop: 'tagName',
      span: 24,
    },
  ]
}

export const organizationTagTableOption = {
  border: true,
  stripe: true,
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  refreshBtn: false,
  menu: true,
  menuAlign: 'center',
  menuSpan: 24,
  column: [
    {
      label: '标签名称',
      prop: 'tagName',
      span: 24,
    },
    {
      label: '创建者',
      prop: 'creator',
      span: 24,
    },
    {
      label: '在职员工人数',
      prop: 'memberCount',
      span: 24,
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss.000',
      span: 24,
      sortable: true,
    },
  ]
}

export const officialTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  refreshBtn: false,
  column: [
  {
      label: '头像',
      width: 100,
      prop: 'avatar',
      solt:true
  },
  {
    label: '官方号名称',
    width: 200,
    prop: 'nickname',
  },
  // {
  //   label: '官方号等级',
  //   width: 150,
  //   prop: 'officialTierName',
  // },
  // {
  //   label: '关联员工姓名',
  //   prop: 'relatedPersonalRealname',
  //   width: 250,
  // },
  {
    label: '帖子数',
    width: 150,
    prop: 'postCount',
    solt: true,
    sortable: true,
  },
  {
    label: '创建时间',
    prop: 'insertedTime',
    sortable: true,
    type: 'datetime',
    format: 'yyyy-MM-dd HH:mm',
    valueFormat: 'yyyy-MM-dd HH:mm:ss.000',
    editDisabled: true,
    addVisdiplay: false,
  }
  ]
}

export const relatedPersonalTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  refreshBtn: false,
  columnBtn: false,
  column: [
    {
      label: '员工号',
      prop: 'unionId',
    },
    {
      label: '员工姓名',
      prop: 'realname',
      width: 200,
    },
    {
      label: '员工Full Name',
      prop: 'nickname',
      width: 200,
    },
    {
      label: '关联状态',
      width: 160,
      type: 'select',
      prop: 'isActive',
      dicData: [{
        label: '正常',
        value: true
      }, {
        label: '失效',
        value: false
      }]
    },
    {
      label: '关联时间',
      width: 160,
      prop: 'insertedTime',
      sortable: true,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm',
      valueFormat: 'yyyy-MM-dd HH:mm:ss.000',
      editDisabled: true,
      addVisdiplay: false,
    },
  ]
}

export const accountTierTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  menu: true,
  columnBtn: false,
  page:false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  column: [
  {
    label: '等级',
    prop: 'tierId',
    width: 100,
  },
  {
    label: '个人号等级称号',
    prop: 'personalName',
    overHidden: true,
    width: 160,
  },
  {
    label: '个人号等级头像效果',
    prop: 'personalAvatarPreview',
    width: 180,
    solt:true
  },
  {
    label: '官方号等级称号',
    prop: 'officialName',
    overHidden: true,
    width: 160,
  },
  {
    label: '官方号等级头像效果',
    prop: 'officialAvatarPreview',
    width: 180,
    solt:true

  }]
}

export function getCertificateType() {
  return [{
    label: '中国居民身份证',
    value: 1,
  },{
    label: '港澳居民来往内地通行证',
    value: 2,
  },{
    label: '台湾居民来往大陆通行证',
    value: 3,
  },{
    label: '护照',
    value: 4,
  },{
    label: '外国人永久居留身份证',
    value: 5,
  },{
    label: '港澳台居民居住证',
    value: 6,
  },{
    label: '其他',
    value: 0,
  }]
}